"use client";

export interface EndpointRow {
  method: string;
  path: string;
  description: string;
  /** Optional plan tag, e.g. "Quant". */
  tag?: string;
}

/** Compact endpoint catalog used on the API landing pages. */
export function EndpointTable({ endpoints }: { endpoints: EndpointRow[] }) {
  return (
    <div className="mx-auto mt-10 max-w-4xl overflow-hidden rounded-xl border border-[#1f2020] bg-[#0d0e0e]">
      {endpoints.map((endpoint, i) => (
        <div
          key={endpoint.path}
          className={`flex flex-col gap-1.5 px-5 py-4 sm:flex-row sm:items-center sm:gap-4 ${
            i > 0 ? "border-t border-[#1c1d1d]" : ""
          }`}
        >
          <div className="flex min-w-0 items-center gap-3 sm:w-[46%]">
            <span className="shrink-0 rounded border border-emerald-500/30 bg-emerald-500/10 px-1.5 py-0.5 font-mono text-[10px] tracking-wide text-emerald-300">
              {endpoint.method}
            </span>
            <span className="truncate font-mono text-[13px] text-[#e8eae9]">{endpoint.path}</span>
          </div>
          <div className="flex min-w-0 flex-1 items-center gap-2.5">
            <span className="text-sm text-white/60">{endpoint.description}</span>
            {endpoint.tag ? (
              <span className="shrink-0 rounded-full border border-[#3a3c3b] px-2 py-0.5 text-[10px] uppercase tracking-wider text-[#8d918f]">
                {endpoint.tag}
              </span>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
